import SEOArticleLayout from "@/components/feature/SEOArticleLayout";

const IMAGE = "https://readdy.ai/api/search-image?query=Minimal%20pricing%20table%20layout%20on%20cream%20background%20with%20three%20elegant%20tier%20cards%2C%20soft%20warm%20lighting%2C%20clean%20Scandinavian%20design%20aesthetic%2C%20professional%20SaaS-style%20presentation%2C%20subtle%20gold%20accents%2C%20harmonious%20composition&width=900&height=1100&seq=seo-article-tarifs-v3&orientation=portrait";

export default function TarifsPage() {
  return (
    <SEOArticleLayout
      title="Tarifs du Hipobuy Spreadsheet"
      subtitle="Découvrez les tarifs et les formules du hipobuy spreadsheet. Comparez les options et choisissez la formule adaptée à votre activité e-commerce."
      heroImageUrl={IMAGE}
      heroImageAlt="Tarifs Hipobuy Spreadsheet"
    >
      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Comprendre les tarifs du Hipobuy Spreadsheet</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Le <strong>hipobuy spreadsheet</strong> propose une gamme de tarifs conçue pour s'adapter à chaque type de vendeur. Que vous débutiez dans l'e-commerce ou que vous gériez un catalogue de plusieurs centaines de produits, vous trouverez une formule qui correspond à vos besoins et à votre budget.
        </p>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          L'investissement dans le <strong>hipobuy spreadsheet</strong> est rapidement rentabilisé grâce au temps gagné et à l'amélioration des marges. Les utilisateurs rapportent un ROI positif dès les premières semaines d'utilisation.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Comparaison des formules</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-foreground-200">
                <th className="py-3 px-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Fonctionnalité</th>
                <th className="py-3 px-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Starter</th>
                <th className="py-3 px-3 text-xs font-semibold text-primary-600 uppercase tracking-wider whitespace-nowrap">Pro</th>
                <th className="py-3 px-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Enterprise</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["Nombre de produits", "Jusqu'à 50", "Jusqu'à 500", "Illimité"],
                ["Suivi automatique", "✓", "✓", "✓"],
                ["Analyse concurrentielle", "Basique", "Avancée", "Personnalisée"],
                ["Alertes prix", "5/jour", "Illimitées", "Illimitées"],
                ["Support", "Email", "Prioritaire", "Dédié"],
                ["Multi-plateforme", "1 plateforme", "3 plateformes", "Illimité"],
              ].map((row, i) => (
                <tr key={i} className="border-b border-background-200">
                  <td className="py-3 px-3 text-xs font-medium text-foreground-800 whitespace-nowrap">{row[0]}</td>
                  <td className="py-3 px-3 text-xs text-foreground-600 whitespace-nowrap">{row[1]}</td>
                  <td className="py-3 px-3 text-xs font-medium text-primary-700 whitespace-nowrap">{row[2]}</td>
                  <td className="py-3 px-3 text-xs text-foreground-600 whitespace-nowrap">{row[3]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Quelle formule choisir ?</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Le choix dépend de la taille de votre catalogue et de vos besoins en automatisation. Pour débuter, la formule Starter du <strong>hipobuy spreadsheet</strong> est idéale. À mesure que votre activité grandit, vous pouvez passer à une formule supérieure sans perdre vos données.
        </p>
        <div className="p-4 bg-primary-50 rounded-2xl border border-primary-100 text-sm text-primary-800">
          <i className="ri-lightbulb-line mr-1.5"></i>
          <strong>Conseil :</strong> Consultez le site officiel pour les tarifs actualisés. Les prix évoluent régulièrement.
        </div>
      </section>

      <div className="mt-8 p-6 bg-accent-50 rounded-2xl border border-accent-100 text-center">
        <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">Consultez les tarifs actualisés</h3>
        <p className="text-sm text-foreground-500 mb-4">Visitez la plateforme officielle pour connaître les tarifs en vigueur du hipobuy spreadsheet.</p>
        <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer">
          Voir les Tarifs
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </SEOArticleLayout>
  );
}